import { IconName } from '~/src/common/components/Icon';

import { PropsFromInputs } from '../../types';

import { Image, Container, Number } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ title, subtitle, image, position, alt }: Props) => {
  return (
    <Container>
      {position != null ? (
        <Number name={position.toString() as IconName} color="PRIMARY" size={30} />
      ) : null}
      <div>
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
      <Image loading="lazy" src={image} alt={alt ?? title} />
    </Container>
  );
};
